import Web3AuthEmbed, { BUTTON_POSITION, WalletUrlConfig, WS_EMBED_BUILD_ENV, WS_EMBED_BUILD_ENV_TYPE, WsEmbedParams } from "@web3auth/ws-embed";

const WALLET_URLS_SAFE: Record<WS_EMBED_BUILD_ENV_TYPE, WalletUrlConfig> = {
  [WS_EMBED_BUILD_ENV.TESTING]: {
    url: "https://lrc-safe.web3auth.io",
    logLevel: "debug",
  },
  [WS_EMBED_BUILD_ENV.DEVELOPMENT]: {
    url: "http://localhost:4050",
    logLevel: "debug",
  },
  [WS_EMBED_BUILD_ENV.PRODUCTION]: {
    url: "https://safe.web3auth.io",
    logLevel: "error",
  },
};

export default class SafeAuthEmbed extends Web3AuthEmbed {
  async init({
    buildEnv = WS_EMBED_BUILD_ENV.PRODUCTION,
    enableLogging = false,
    chainConfig,
    showWidgetButton = false,
    buttonPosition = BUTTON_POSITION.BOTTOM_LEFT,
    walletUrls,
  }: WsEmbedParams = {}): Promise<void> {
    return super.init({ buildEnv, enableLogging, chainConfig, showWidgetButton, buttonPosition, walletUrls: walletUrls || WALLET_URLS_SAFE });
  }
}
